import { render, staticRenderFns } from "./ProfileDeactivateReveals.vue?vue&type=template&id=8dc1b184&"
import script from "./ProfileDeactivateReveals.vue?vue&type=script&lang=js&"
export * from "./ProfileDeactivateReveals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports